import { FadeIn, MaskedLine, Eyebrow } from "./Reveal";

const STEPS = [
  { n: "01", t: "Discover", d: "Understanding the vision, story and atmosphere." },
  { n: "02", t: "Create", d: "Developing the creative direction and experience." },
  { n: "03", t: "Curate", d: "Bringing together every visual and experiential detail." },
  { n: "04", t: "Deliver", d: "Seamless planning, production and execution." },
];

export const Approach = () => (
  <section data-testid="approach-section" className="bg-pale/60 py-32 sm:py-40">
    <div className="mx-auto max-w-[1600px] px-6 sm:px-10 lg:px-16">
      <FadeIn>
        <Eyebrow>The Sora Approach</Eyebrow>
      </FadeIn>
      <h2 className="mt-8 font-serif font-light leading-[1.05] text-ink text-[clamp(2.4rem,5.5vw,4.8rem)]">
        <MaskedLine delay={0.1}>
          From first idea to <span className="italic text-olive">final detail.</span>
        </MaskedLine>
      </h2>

      <div className="mt-24 grid gap-14 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <FadeIn key={s.n} delay={i * 0.12} amount={0.4}>
            <div data-testid={`approach-step-${s.n}`}>
              <span
                className="block font-serif text-[6.5rem] font-light leading-none text-transparent sm:text-[7.5rem]"
                style={{ WebkitTextStroke: "1px #9D9E73" }}
              >
                {s.n}
              </span>
              <h3 className="mt-8 text-xs font-semibold uppercase tracking-[0.45em] text-ink">
                {s.t}
              </h3>
              <p className="mt-5 max-w-[26ch] text-sm font-light leading-relaxed text-ink/70">
                {s.d}
              </p>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);
